import { ArrayContainsObjectWithPropertyBaseValueConverter } from 'General/Resources/ValueConverters/ArrayContainsObjectWithPropertyBase';

export class ArrayContainsObjectWithPropertyValueConverter extends ArrayContainsObjectWithPropertyBaseValueConverter {

}